import Tooltip from "./Tooltip";
import './tooltip.scss';
export default Tooltip;